import {
  cpnFormatter,
  fileFormatter,
  translateToLocalDate,
} from "utils/helpers";

export type AliErrorRecord = {
  msag_id?: string | undefined | null;
  orig_msag_id?: string | undefined | null;
  sop_id?: string | number | undefined;
  FOC?: string | undefined;
  CPN?: string | undefined;
  // HNP?: string | undefined;
  HNO?: string | undefined;
  // HNE?: string | undefined;
  HNS?: string | undefined;
  PRD?: string | undefined;
  STN?: string | undefined;
  STS?: string | undefined;
  POD?: string | undefined;
  MCN?: string | undefined;
  STA?: string | undefined;
  LOC?: string | undefined;
  NAM?: string | undefined;
  CLS?: string | undefined;
  TYS?: string | undefined;
  Exchange?: string | undefined;
  lecESN?: string | undefined;
  MainNPA?: string | undefined;
  MainNumber?: string | undefined;
  OrderNumber?: string | undefined;
  ExtractDate?: string | undefined;
  lecCOI?: string | undefined;
  CPF?: string | undefined;
  SourceID?: string | undefined;
  lecZipCode?: string | undefined;
  lecZipExtension?: string | undefined;
  GeneralUse?: string | undefined;
  CustomerCode?: string | undefined;
  Comments?: string | undefined;
  lecLON?: string | undefined;
  lecLAT?: string | undefined;
  lecELV?: string | undefined;
  CellID?: string | undefined;
  SectorID?: string | undefined;
  TARCode?: string | undefined;
  Reserved1?: string | undefined;
  AltNumber?: string | undefined;
  ExpandedExtractDate?: string | undefined;
  NENAReserved?: string | undefined;
  DataProviderID?: string | undefined;
  Reserved2?: string | undefined;
  privateCit?: boolean;
  dd?: number;
  created?: string | undefined;
  created_by?: string | undefined;
  last_modified?: string | undefined;
  modified_by?: string | undefined;
  web_login?: string | undefined;
  ali_tmp_idx?: string | undefined | null;
  job_id?: string | undefined | null;
  error?: string | number | undefined;
  errorDescription?: string | undefined;
  was_in_ali?: string | undefined;
  file?: string | undefined;
  processed?: string | undefined;
  idx?: string | number | undefined;
};

export function getALIErrorExportColumns() {
  return {
    "Telephone Number": "CPN",
    Error: "error",
    "Error Message": "errorDescription",
    "Function of Change": "FOC",
    "House Number": "HNO",
    "House Number Suffix": "HNS",
    "Prefix Directional": "PRD",
    "Street Name": "STN",
    "Street Suffix": "STS",
    "Post Directional": "POD",
    "MSAG Community Name": "MCN",
    County: "lecCOI",
    State: "STA",
    Location: "LOC",
    "Customer Name": "NAM",
    "NENA ID": "CPF",
    "ZIP Code": "lecZipCode",
    ESN: "lecESN",
    "Type of Service": "TYS",
    "Class of Service": "CLS",
    File: "file",
    Record: "ali_tmp_idx",
    Created: "created",
  };
}

export const remove = (cell, formatterParams, onRendered) => {
  return `<calcite-icon id="trashIcon" icon="trash" scale="s"></calcite-icon>`;
};

export const options = (cell, formatterParams, onRendered) => {
  let id = cell.getData().idx;
  const hasWritePermission = formatterParams?.hasWritePermission;

  if (hasWritePermission) {
    return `
      <a href="/ali-errors/edit/${id}"  title="Edit ALI Error">
        <calcite-icon id="editError-${id}" icon="pencil" scale="s" style="margin-right:8px;"></calcite-icon>
      </a>
      <a href="/ali-errors/delete/${id}" title="Delete ALI Error">
        <calcite-icon id="deleteError-${id}" icon="trash" scale="s"></calcite-icon>
      </a>
    `;
  } else {
    return `
      <a href="/ali-errors/view/${id}" title="View ALI Error">
        <calcite-icon id="viewError-${id}" icon="view-visible" scale="s"></calcite-icon>
      </a>
    `;
  }
};

export function getAliErrorColumns(hasWritePermission: boolean) {
  const aliErrorColumns: ColumnDefinition[] = [
    // Displayed columns
    {
      title: "",
      field: "actions",
      formatter: options,
      formatterParams: {
        hasWritePermission,
      },
      width: 75,
      minWidth: 50,
      hozAlign: "center",
      headerSort: false,
      headerFilter: false,
    },
    {
      title: "Telephone Number",
      field: "CPN",
      formatter: cpnFormatter,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 185,
      // minWidth: 120,
    },
    {
      title: "Error",
      field: "error",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 185,
      // minWidth: 120,
    },
    {
      title: "Function of Change",
      field: "FOC",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 185,
      // minWidth: 120,
    },
    {
      title: "House Number",
      field: "HNO",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "House Number Suffix",
      field: "HNS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 200,
      // minWidth: 50,
    },
    {
      title: "Prefix Directional",
      field: "PRD",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 170,
      // minWidth: 50,
    },
    {
      title: "Street Name",
      field: "STN",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 135,
      // minWidth: 60,
    },
    {
      title: "Street Suffix",
      field: "STS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 135,
      // minWidth: 50,
    },
    {
      title: "Post Directional",
      field: "POD",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "MSAG Community Name",
      field: "MCN",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 230,
      // minWidth: 110,
    },
    {
      title: "County",
      field: "lecCOI",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 100,
      // minWidth: 50,
    },
    {
      title: "State",
      field: "STA",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 100,
      // minWidth: 50,
    },
    {
      title: "Location",
      field: "LOC",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 110,
      // minWidth: 110,
    },
    {
      title: "Customer Name",
      field: "NAM",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 175,
      // minWidth: 110,
    },
    {
      title: "NENA ID",
      field: "CPF",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 120,
      // minWidth: 50,
    },
    {
      title: "ZIP Code",
      field: "lecZipCode",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 120,
      // minWidth: 50,
    },
    {
      title: "ESN",
      field: "lecESN",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 100,
      // minWidth: 50,
    },
    {
      title: "Type of Service",
      field: "TYS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "Class of Service",
      field: "CLS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "File",
      field: "file",
      formatter: fileFormatter,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "Record",
      field: "ali_tmp_idx",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "Created",
      field: "created",
      mutator: translateToLocalDate,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "Last Modified",
      field: "last_modified",
      mutator: translateToLocalDate,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 175,
    },
  ];

  // if(hasEditPermission) {
  //   aliErrorColumns.unshift({
  //     title: "",
  //     formatter: remove,
  //     width: 50,
  //     minWidth: 50,
  //     hozAlign: "center",
  //     headerSort: false,
  //   })
  // }

  return aliErrorColumns;
}
